import { createContext, useContext } from 'react';
import type { TransitionController } from '../../core-transition-component';

export type TransitionControllersContextType = Set<TransitionController> | undefined;

export function createTransitionControllerContext(): {
  TransitionControllersContext: React.Context<TransitionControllersContextType>;
  useTransitionControllers: () => TransitionControllersContextType;
} {
  const TransitionControllersContext = createContext<TransitionControllersContextType>(undefined);

  function useTransitionControllers(): TransitionControllersContextType {
    return useContext(TransitionControllersContext);
  }

  return {
    TransitionControllersContext,
    useTransitionControllers,
  };
}

export const {
  TransitionControllersContext: TransitionPresenceTransitionControllersContext,
  useTransitionControllers: useTransitionPresenceTransitionController,
} = createTransitionControllerContext();
